<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <div class="flex align-center justify-between">
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>姓<i style="padding-left: 14px;"></i>名：</span>
                            <el-input v-model="name" placeholder="请输入姓名" class="flex-sub"></el-input>
                        </div>
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>手机号：</span>
                            <el-input v-model="phone" placeholder="请输入手机号" class="flex-sub"></el-input>
                        </div>
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>服务类型：</span>
                            <el-select v-model="service_type" placeholder="请选择服务类型" class="flex-sub">
                                <el-option
                                    v-for="item in serviceList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>服务状态：</span>
                            <el-select v-model="service_state" placeholder="请选择服务状态" class="flex-sub">
                                <el-option
                                    v-for="item in serviceState"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>服务满意度：</span>
                            <el-select v-model="comment" placeholder="请选择服务满意度" class="flex-sub">
                                <el-option
                                    v-for="item in commentList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>


                    </div>

                    <fiveLevel @upFive="upFive"/>
                    <div class="flex align-center justify-between">
                        <div class="flex align-center margin-right-sm margin-bottom-xs basis-sm">
                            <span>时间筛选：</span>
                            <el-date-picker
                                v-model="chioseTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <el-button type="primary" @click="hanldSearch">搜索</el-button>
                <el-button type="primary" @click="exportData" :loading="export_loading">导出</el-button>
            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                </div>
            </div>

            <el-table
                :data="residentList"
                header-row-class-name="table-header"
                row-class-name="table-row"
                alig="center"
                border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
                <el-table-column label="联系人" prop="lianxiren"></el-table-column>
                <el-table-column label="居民姓名" prop="name"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column label="楼门户">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.building_name }}-{{ scope.row.element_name }}-{{ scope.row.room_name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="服务申请时间" prop="add_time"></el-table-column>
                <el-table-column label="服务结束时间" prop="end_time"></el-table-column>
                <el-table-column label="服务类型" prop="service_type">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.cate }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="服务状态" prop="state">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.state }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="服务评价" prop="comment">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.comment | comment }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column label="备注" width="220">
                    <template slot-scope="scope">
                        <div class="table-operate" v-if="!scope.row.desc">
                            <el-button
                                size="small"
                                type="primary"
                                @click="refuseItem(scope.row.id)">备注
                            </el-button>
                        </div>
                        <div class="table-operate" v-else>
                            {{ scope.row.desc }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="服务照片" width="220">
                    <template slot-scope="scope">
                        <div class="flex flex-wrap">
                            <el-image
                                v-for="(item,index) in scope.row.images"
                                :key="index"
                                :src="item"
                                :preview-src-list="[item]"
                                style="width: 100px; height: 100px;">
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" v-if="[3,5].includes(user.power)">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button
                                size="small"
                                type="primary"
                                @click="delService(scope.row.id)">删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                v-if="residentList.length > 0"
                class="page-all"
                background
                @current-change="getResidentList"
                :current-page.sync="page"
                :page-size="limit"
                layout="prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {commentList, downloadFile, filesCN, serviceList, serviceState, zhDate} from "@/utils/utils";
import fiveLevel from '@/components/five-level'
import {beizhuServiceOrder, delIngProjectService, exportXiaoquServiceList, xiaoquServiceList} from "@/api/weilao";
import {upFeil} from "@/config";


export default {
    name: "resident-data",
    data() {
        return {
            FILE_URL:upFeil,
            serviceList: [],
            serviceState: serviceState,
            commentList: commentList,
            name: '',
            phone: '',
            service_type: '',
            service_state: '',
            comment: '',
            relation: 0,
            project: 0,
            community: 0,
            building: 0,
            unit: 0,
            room: 0,
            chioseTime: [],
            page: 1,
            limit: 10,
            total: 0,
            residentList: [],
            setId: 0,
            setItem: {},

            export_loading:false

        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        server() {
            return this.$store.state.server
        }
    },
    created() {

        this.$emit("setIndex", this.$route.path, "双暖为老 / 服务申请列表", false);
        this.serviceList = this.server.length > 0 ? [...[{value: 0, label: '全部'}], ...this.server] : serviceList
        this.getResidentList()
    },
    components: {
        fiveLevel,
    },
    methods: {
        //  备注
        refuseItem(id) {
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
            }).then(({value}) => {
                this.sureRefuse(id, value);
            })
        },
        async sureRefuse(id, str) {
            let _state = await beizhuServiceOrder(id, str);
            this.getResidentList();
            this.$message.success(_state.info);
        },


        //  搜索
        hanldSearch() {
            this.page = 1
            this.getResidentList()
        },
        async exportData() {
            if (!this.project) return this.$message.error('请选择服务社区')
            if (!this.chioseTime.length) return this.$message.error('请选择时间')
            this.export_loading = true
            let _data = await exportXiaoquServiceList(
                    this.name,
                    this.phone,
                    this.project,
                    this.community,
                    this.building,
                    this.unit,
                    this.room,
                    this.service_type,
                    this.service_state,
                    this.comment,
                    this.chioseTime.length > 0 ? zhDate(new Date(this.chioseTime[0])) : '',
                    this.chioseTime.length > 0 ? zhDate(new Date(this.chioseTime[1])) : '',
                )
              this.export_loading = false
              downloadFile(_data.data,'服务记录.xls');
        },

        //  获取居民列表
        async getResidentList() {
            let _data = await xiaoquServiceList(
                this.name,
                this.phone,
                this.project,
                this.community,
                this.building,
                this.unit,
                this.room,
                this.service_type,
                this.service_state,
                this.comment,
                this.page,
                this.limit,
                this.chioseTime.length > 0 ? zhDate(new Date(this.chioseTime[0])) : '',
                this.chioseTime.length > 0 ? zhDate(new Date(this.chioseTime[1])) : '',
            )
            if (_data.status === 200) {
                _data.data.map(item => {
                    if (item.state === 1) item.state = '新申请'
                    if (item.state === 2) item.state = '处理中'
                    if (item.state === 3 && item.is_finished === 0) item.state = '处理中'
                    if (item.state === 3 && item.is_finished === 1) item.state = '已完成'
                    if (item.state === 4) item.state = '已取消'
                    // item.service_type = filesCN(Number(item.service_type), this.serviceList)
                })
            }
            this.residentList = _data.data
            this.total = _data.total_number
        },
        //  同步更新五级联动
        upFive(val) {
            this.project = val.project
            this.community = val.community
            this.building = val.building
            this.unit = val.unit
            this.room = val.room
        },
        //  删除文件
        delService(id) {
            this.$confirm('您确定要删除该服务吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delIngProjectService(id);
            if (this.residentList.length === 1 && this.page > 1) {
                this.page--;
            }
            this.getResidentList()
            this.$message.success(_state.info);
        },
    },
    filters: {

        state(val) {
            return filesCN(Number(val), serviceState)
        },
        comment(val) {
            return filesCN(Number(val), commentList)
        }
    },
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
